/**
 * Sort workspaces alphabetically by name (case-insensitive)
 */
export function sortWorkspacesByName<T extends { name: string }>(workspaces: T[]): T[] {
  return [...workspaces].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  );
}
